import React, { Fragment, useContext, useEffect, useState } from "react";
import {
  Button,
  Col,
  Collapse,
  DatePicker,
  Input,
  Popover,
  Row,
  Select,
  Table,
  Tabs,
  Tag,
} from "antd";
import { Badge, Space, Switch } from "antd";
import {
  UploadOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileZipOutlined,
  DownloadOutlined,
  DownCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import GuarantorDetails from "./GuarantorDetails";
import LoanSwitchBox from "./LoanSwitchBox";
import LoanCaseData from "./LoanCaseData";
import moment from "moment";
import {
  downloadApplications,
  objToArray,
  downloadDocuments,
  downloadDocumentsUnzip,
  handleDownload,
} from "../../common/Utilities";
import { CommomPermission, IMAGE_BASE_URL } from "../../common/Constants";
import NotificationCarousel from "./NotificationCarousel";
import DocumentPreview from "./DocumentPreview";
import GurantorEdit from "./GurantorEdit";
import { useDispatch, useSelector } from "react-redux";
import { setLoanApplicationDetailsFilter } from "../../redux/slice/dealerCommFilterSlice";
import { ReactComponent as CircleArrow } from "../../images/circle-arrow.svg";
import axios from "../../axios/axios";
import dayjs from "dayjs";
import { AuthenticationContext } from "../../App";
import { toast } from "react-toastify";
import { resetGuarantorsButton, addGuarantorButton, resetGuarantors } from "../../redux/slice/guarantorInfoSlice";

const Constant = {
  1: "pending",
  2: "approved",
  3: "counter_offered",
  4: "rejected",
};

const CaseTabDetails = ({
  type,
  data,
  reloadData,
  applTab,
  pagePermission,
}) => {
  const isDisbursed = data?.disbursementinfo !== null && data?.disbursementinfo !== undefined ? true : false
  const loanAppfilters = useSelector(
    (state) => state.dealerCommFilter?.loanAppDetailsFilter
  );
  const removeGuarantorLabel = useSelector((state) => state.guarantorInfo.removeGuarantorLabel);
  const { guarantorButtonId, minIncome, guarantorButtonTime, guarantorCount, guarantorDetails } = useSelector((state) => state.guarantorInfo);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { authData } = useContext(AuthenticationContext);
  const FlooringPErmission = authData?.permissions
    ?.filter((it) => it.name === "loan")
    ?.map((itx) => itx?.submodules)
    .flat()
    ?.filter((its) => its?.name === "new-loan-application");
  const FloorPagePErmission =
    FlooringPErmission !== undefined && FlooringPErmission?.length > 0
      ? FlooringPErmission[0]
      : CommomPermission;
  const [settings, setSettings] = useState({});
  const [disbursementForm, setDisbursementForm] = useState([]);

  const [showMore, setShowMore] = useState(false);
  const [compMount, setCompMount] = useState(false);
  const [applActiveTab, setAapplActiveTab] = useState(
    applTab !== undefined ? Constant[applTab] : "pending"
  );

  const [searchVal, setSearchVal] = useState("");
  const [loanDetailName, setLoanDetailName] = useState(
    loanAppfilters?.loanDetailName !== undefined &&
      loanAppfilters?.loanDetailName !== ""
      ? loanAppfilters?.loanDetailName
      : "All"
  );
  const [loanDetailSortkey, setLoanDetailSortkey] = useState(
    loanAppfilters?.loanDetailSortkey !== undefined &&
      loanAppfilters?.loanDetailSortkey !== ""
      ? loanAppfilters?.loanDetailSortkey
      : "lhComm"
  );

  const [loanTabDetails, setLoanTabDetails] = useState([]);
  const [originalloanTabDetails, setOriginalLoanTabDetails] = useState([]);
  const [selectedGuarantorTab, setSelectedGuarantorTab] = useState(1);
  const [selGurantor, setSelGurantor] = useState(0);
  const [documentPreview, setDocumentPreview] = useState(false);
  const [documentUrl, setDocumentUrl] = useState("");
  const [fileDocumentType, setFileDocumentType] = useState("");
  const [downloadPopOver, setDownloadPopOver] = useState(false);
  const [gurantorEdit, setGuarntorEdit] = useState(false);
  const [clickAddBtn, setClickAddBtn] = useState(false);

  const getButtonCount = JSON.parse(localStorage.getItem("guarantorcount"));
  const redirectStatus = localStorage.getItem("redirectStatus");
  const tabStatus = sessionStorage.getItem("updatedStatus");


  const handleOpenChange = (newOpen) => {
    setDownloadPopOver(newOpen);
  };
  let dataDocuments = [];
  let withStatusUpdate = [];
  let withoutStatusUpdate = [];
  let guaranRemoved = [];
  let disbDate = "";
  let disbRemarks = "";
  if (type == "vehicle") {
    dataDocuments = objToArray(data.vehicle_documents);
  } else if (type == "applicant") {
    dataDocuments = objToArray(data.applicant_docs);
  } else if (type == "guarantor") {
    if (data.guarantor_details != undefined) {
      withStatusUpdate = data?.guarantor_details.filter(
        (item) => item.guarantor_status_update != null
      );
      withoutStatusUpdate = data?.guarantor_details.filter(
        (item) => item.guarantor_status_update == null
      );
    }
    if (data?.deleted_guarantors) {
      guaranRemoved = data?.deleted_guarantors;
    }
  } else if (type == "disbursement") {
    if (data.disbursementinfo) {
      disbRemarks = data?.disbursementinfo?.remarks
        ? data?.disbursementinfo?.remarks
        : "N/A";
      disbDate = data?.disbursementinfo?.disbursement_date
        ? moment(data?.disbursementinfo?.disbursement_date).format("DD-MM-YYYY")
        : "N/A";
      dataDocuments = [
        {
          transaction_history: data?.disbursementinfo?.transaction_history,
        },
        {
          vehicle_information: data?.disbursementinfo?.vehicle_information,
        },
        {
          vehicle_acknowledgement:
            data?.disbursementinfo?.vehicle_acknowledgement,
        },
        {
          insurance_certificate: data?.disbursementinfo?.insurance_certificate,
        },
        {
          number_retention_letter:
            data?.disbursementinfo?.number_retention_letter,
        },
      ];
    }
  }

  const fileType = (url) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];
    const documentExtensions = ["pdf", "doc", "docx", "txt", "rtf"];
    const lastDotIndex = url.lastIndexOf(".");
    if (lastDotIndex !== -1) {
      const fileExtension = url.slice(lastDotIndex + 1);
      if (imageExtensions.includes(fileExtension.toLowerCase())) {
        setFileDocumentType("Image");
      } else if (documentExtensions.includes(fileExtension.toLowerCase())) {
        setFileDocumentType("Document");
      }
    }
  };

  const GuarantorItems = [
    {
      label: (
        <span className="mr-5">
          <Badge
            showZero
            color={selectedGuarantorTab == 1 ? "#00ae11" : "#d4d4d4"}
            count={withoutStatusUpdate.length}
            offset={[15, 8]}
          >
            Available Guarantor
          </Badge>
        </span>
      ),
      key: 1,
      children: (
        <GuarantorDetails
          guarantorType={"available"}
          data={withoutStatusUpdate}
          reloadData={reloadData}
          selectGaurantor={(val) => {
            setSelGurantor(val);
          }}
          comp={{ setDocumentPreview, setDocumentUrl, fileType }}
        />
      ),
    },
    {
      label: (
        <span className="mr-5">
          <Badge
            showZero
            color={selectedGuarantorTab == 2 ? "#ff4d4f" : "#d4d4d4"}
            count={withStatusUpdate.length}
            offset={[15, 8]}
          >
            Rejected Guarantor
          </Badge>
        </span>
      ),
      key: 2,
      children: (
        <GuarantorDetails
          guarantorType={"rejected"}
          data={withStatusUpdate}
          reloadData={reloadData}
          selectGaurantor={(val) => {
            setSelGurantor(val);
          }}
          comp={{ setDocumentPreview, setDocumentUrl, fileType }}
        />
      ),
    },
  ];

  const AccordionHeader = ({ title, icon, scheme, productName }) => {
    return (
      <div className="ant-accordion-header">
        <div className="ant-accordion-header-info">
          {icon && (
            <div className="ant-accordion-logo">
              <img src={`${IMAGE_BASE_URL}${icon}`} alt="accordion logo" />
            </div>
          )}
          <div className="ant-accordion-info">
            <span>{"[ " + scheme + " ] "}</span>
            <h3>{title}</h3>
            <h4>{productName}</h4>
          </div>
        </div>
      </div>
    );
  };

  let Loanitems = [];

  useEffect(() => {
    if (compMount) {
      switch (applTab) {
        case "1":
          const pendingFilterItem = originalloanTabDetails.filter(
            (item) => item.applstatus === "pending"
          );
          setLoanTabDetails(pendingFilterItem);
          setAapplActiveTab("pending");
          setSearchVal("");
          break;
        case "2":
          const approvedFilterItem = originalloanTabDetails.filter(
            (item) => item.applstatus === "approved"
          );
          setLoanTabDetails(approvedFilterItem);
          setAapplActiveTab("approved");
          setSearchVal("");
          break;
        case "3":
          const counterFilterItem = originalloanTabDetails.filter(
            (item) => item.applstatus === "counter_offered"
          );
          setLoanTabDetails(counterFilterItem);
          setAapplActiveTab("counter_offered");
          setSearchVal("");
          break;
        case "4":
          const rejectedFilterItem = originalloanTabDetails.filter(
            (item) => item.applstatus === "rejected"
          );
          setLoanTabDetails(rejectedFilterItem);
          setAapplActiveTab("rejected");
          setSearchVal("");
          break;
        default:
          break;
      }
    }
  }, [applTab]);

  const SortItems = (data) => {
    let items = [...data]
      .sort(function (a, b) {
        return a?.dealerComm - b?.dealerComm;
      })
      .map((item) => {
        item.products.sort(
          (a, b) =>
            a?.dealer_commission_percentage - b?.dealer_commission_percentage
        );
        return item;
      });
    return items;
  };


  useEffect(() => {
    let loanItemsData = [];
    let LoanitemTabs = [];
    if (data.products != undefined && data.products != null) {
      if (loanDetailName == "All") {
        loanItemsData = [];
        if (
          data.products?.Bank != undefined &&
          data.products?.Bank.length > 0
        ) {
          let bank_data = data.products.Bank;
          bank_data.map((dataRow) => {
            loanItemsData.push({
              provider_name: dataRow.providerinfo?.name,
              provider_id: dataRow.providerinfo?.id,
              provider_icon: dataRow.providerinfo?.icon,
              sortInterestData: dataRow.int_rate,
              application_product_status: dataRow.application_product_status,
              main_dis_info: data.disbursementinfo,
              product_id: dataRow.id,
              products: [
                {
                  product_name: dataRow.name,
                  provider_name: dataRow.name,
                  interest: dataRow.int_rate,
                  interest_id: dataRow.activeinterest?.id,
                  product_id: dataRow.id,
                  agentcommision: dataRow.agentcommision,
                  application_product: dataRow.application_product,
                  loan_amt: parseInt(dataRow.loanamount).toFixed(0),
                  tenor: dataRow.tenure,
                  dealer_commission_percentage: dataRow.commision_percentage,
                  dealer_commission_amount:
                    parseInt(dataRow.loanamount) *
                    (parseFloat(dataRow.commision_percentage) / 100),
                  admin_fee: dataRow.adminfee,
                  mnthly_installement: dataRow.monthly_installment,
                  scheme: dataRow.schemeinfo?.name,
                  status: dataRow.agentupdatestatus,
                  parf: dataRow.parfvalue,
                  available_guarantors: data.guarantor_details.filter(
                    (item) => item.guarantor_status_update == null
                  ),
                  type: "bank",
                  agentupdatestatus: dataRow.agentupdatestatus,
                  counterData: dataRow.counterData,
                  furnish_guarantors: dataRow.furnish_guarantors,
                  application_product_status:
                    dataRow.application_product_status,
                  is_counter_offer_accepted: dataRow.is_counter_offer_accepted,
                  agent_name: dataRow?.agentInfo?.name,
                  product_dis_info: dataRow?.disbursementinfo,
                  aa_files: dataRow?.aa_files,
                  app_provid_name: dataRow?.providerName,
                  last_installment: dataRow.last_installment,
                  remarks: dataRow.remarks,
                  terms_and_conditions: dataRow.terms_and_conditions,
                },
              ],
              loan_application_id: dataRow.id,
              dealer_id: dataRow.dealer,
            });
          });
        }
        if (
          data.products?.Financial_Institution != undefined &&
          data.products?.Financial_Institution.length > 0
        ) {
          let financial_data = data.products.Financial_Institution;
          financial_data.map((dataRow) => {
            loanItemsData.push({
              provider_name: dataRow.providerinfo?.name,
              provider_id: dataRow.providerinfo?.id,
              provider_icon: dataRow.providerinfo?.icon,
              sortInterestData: dataRow.int_rate,
              application_product_status: dataRow.application_product_status,
              main_dis_info: data.disbursementinfo,
              product_id: dataRow.id,
              products: [
                {
                  product_name: dataRow.name,
                  provider_name: dataRow.name,
                  interest: dataRow.int_rate,
                  interest_id: dataRow.activeinterest?.id,
                  product_id: dataRow.id,

                  agentcommision: dataRow.agentcommision,
                  application_product: dataRow.application_product,
                  loan_amt: parseInt(dataRow.loanamount).toFixed(0),
                  tenor: dataRow.tenure,
                  dealer_commission_percentage: dataRow.commision_percentage,
                  dealer_commission_amount:
                    parseInt(dataRow.loanamount) *
                    (parseFloat(dataRow.commision_percentage) / 100),
                  admin_fee: dataRow.adminfee,
                  mnthly_installement: dataRow.monthly_installment,
                  scheme: dataRow.schemeinfo?.name,
                  status: dataRow.agentupdatestatus,
                  parf: dataRow.parfvalue,
                  available_guarantors: data.guarantor_details.filter(
                    (item) => item.guarantor_status_update == null
                  ),
                  type: "financial_institution",
                  agentupdatestatus: dataRow.agentupdatestatus,
                  counterData: dataRow.counterData,
                  furnish_guarantors: dataRow.furnish_guarantors,
                  application_product_status:
                    dataRow.application_product_status,
                  is_counter_offer_accepted: dataRow.is_counter_offer_accepted,
                  agent_name: dataRow?.agentInfo?.name,
                  product_dis_info: dataRow?.disbursementinfo,
                  aa_files: dataRow?.aa_files,
                  app_provid_name: dataRow?.providerName,
                  last_installment: dataRow.last_installment,
                  remarks: dataRow.remarks,
                  terms_and_conditions: dataRow.terms_and_conditions,
                },
              ],
              loan_application_id: dataRow.id,
              dealer_id: dataRow.dealer,
            });
          });
        }
        if (
          data.products?.["In-House"] != undefined &&
          data.products?.["In-House"].length > 0
        ) {
          let inhouse_data = data.products?.["In-House"];
          inhouse_data.map((dataRow) => {
            loanItemsData.push({
              provider_name: dataRow.name,
              provider_id: dataRow.id,
              provider_icon: dataRow.icon,
              sortInterestData: dataRow.int_rate,
              application_product_status: dataRow.application_product_status,
              main_dis_info: data.disbursementinfo,
              product_id: dataRow.id,
              products: [
                {
                  product_name: dataRow.name,
                  provider_name: dataRow.name,
                  interest: dataRow.int_rate,
                  interest_id: dataRow.activeinterest?.id,
                  product_id: dataRow.id,

                  agentcommision: dataRow.agentcommision,
                  application_product: dataRow.application_product,
                  loan_amt: parseInt(dataRow.loanamount).toFixed(0),
                  tenor: dataRow.tenure,
                  dealer_commission_percentage: dataRow.commision_percentage,
                  dealer_commission_amount:
                    parseInt(dataRow.loanamount) *
                    (parseFloat(dataRow.commision_percentage) / 100),
                  admin_fee: dataRow.adminfee,
                  mnthly_installement: dataRow.monthly_installment,
                  scheme: dataRow.schemeinfo?.name,
                  status: dataRow.agentupdatestatus,
                  parf: dataRow.parfvalue,
                  available_guarantors: data.guarantor_details.filter(
                    (item) => item.guarantor_status_update == null
                  ),
                  type: "In-House",
                  agentupdatestatus: dataRow.agentupdatestatus,
                  counterData: dataRow.counterData,
                  furnish_guarantors: dataRow.furnish_guarantors,
                  application_product_status:
                    dataRow.application_product_status,
                  is_counter_offer_accepted: dataRow.is_counter_offer_accepted,
                  agent_name: dataRow?.agentInfo?.name,
                  product_dis_info: dataRow?.disbursementinfo,
                  aa_files: dataRow?.aa_files,
                  app_provid_name: dataRow?.providerName,
                  last_installment: dataRow.last_installment,
                  remarks: dataRow.remarks,
                  terms_and_conditions: dataRow.terms_and_conditions,
                },
              ],
              loan_application_id: dataRow.id,
              dealer_id: dataRow.dealer,
            });
          });
        }
      } else if (loanDetailName == "Bank") {
        loanItemsData = [];
        if (
          data.products?.Bank != undefined &&
          data.products?.Bank.length > 0
        ) {
          let bank_data = data.products.Bank;
          bank_data.map((dataRow) => {
            loanItemsData.push({
              provider_name: dataRow.providerinfo?.name,
              provider_id: dataRow.providerinfo?.id,
              provider_icon: dataRow.providerinfo?.icon,
              sortInterestData: dataRow.int_rate,
              application_product_status: dataRow.application_product_status,
              main_dis_info: data.disbursementinfo,
              product_id: dataRow.id,
              products: [
                {
                  product_name: dataRow.name,
                  provider_name: dataRow.name,
                  interest: dataRow.int_rate,
                  interest_id: dataRow.activeinterest?.id,
                  product_id: dataRow.id,

                  agentcommision: dataRow.agentcommision,
                  application_product: dataRow.application_product,
                  loan_amt: parseInt(dataRow.loanamount).toFixed(0),
                  tenor: dataRow.tenure,
                  dealer_commission_percentage: dataRow.commision_percentage,
                  dealer_commission_amount:
                    parseInt(dataRow.loanamount) *
                    (parseFloat(dataRow.commision_percentage) / 100),
                  admin_fee: dataRow.adminfee,
                  mnthly_installement: dataRow.monthly_installment,
                  scheme: dataRow.schemeinfo?.name,
                  status: dataRow.agentupdatestatus,
                  parf: dataRow.parfvalue,
                  available_guarantors: data.guarantor_details.filter(
                    (item) => item.guarantor_status_update == null
                  ),
                  type: "bank",
                  agentupdatestatus: dataRow.agentupdatestatus,
                  counterData: dataRow.counterData,
                  furnish_guarantors: dataRow.furnish_guarantors,
                  application_product_status:
                    dataRow.application_product_status,
                  is_counter_offer_accepted: dataRow.is_counter_offer_accepted,
                  agent_name: dataRow?.agentInfo?.name,
                  product_dis_info: dataRow?.disbursementinfo,
                  aa_files: dataRow?.aa_files,
                  app_provid_name: dataRow?.providerName,
                  last_installment: dataRow.last_installment,
                  remarks: dataRow.remarks,
                  terms_and_conditions: dataRow.terms_and_conditions,
                },
              ],
              loan_application_id: dataRow.id,
              dealer_id: dataRow.dealer,
            });
          });
        }
      } else if (loanDetailName == "Financial_Institution") {
        loanItemsData = [];
        if (
          data.products?.Financial_Institution != undefined &&
          data.products?.Financial_Institution.length > 0
        ) {
          let financial_data = data.products.Financial_Institution;
          financial_data.map((dataRow) => {
            loanItemsData.push({
              provider_name: dataRow.providerinfo?.name,
              provider_id: dataRow.providerinfo?.id,
              provider_icon: dataRow.providerinfo?.icon,
              sortInterestData: dataRow.int_rate,
              application_product_status: dataRow.application_product_status,
              main_dis_info: data.disbursementinfo,
              product_id: dataRow.id,
              products: [
                {
                  product_name: dataRow.name,
                  provider_name: dataRow.name,
                  interest: dataRow.int_rate,
                  interest_id: dataRow.activeinterest?.id,
                  product_id: dataRow.id,

                  agentcommision: dataRow.agentcommision,
                  application_product: dataRow.application_product,
                  loan_amt: parseInt(dataRow.loanamount).toFixed(0),
                  tenor: dataRow.tenure,
                  dealer_commission_percentage: dataRow.commision_percentage,
                  dealer_commission_amount:
                    parseInt(dataRow.loanamount) *
                    (parseFloat(dataRow.commision_percentage) / 100),
                  admin_fee: dataRow.adminfee,
                  mnthly_installement: dataRow.monthly_installment,
                  scheme: dataRow.schemeinfo?.name,
                  status: dataRow.agentupdatestatus,
                  parf: dataRow.parfvalue,
                  available_guarantors: data.guarantor_details.filter(
                    (item) => item.guarantor_status_update == null
                  ),
                  type: "financial_institution",
                  agentupdatestatus: dataRow.agentupdatestatus,
                  counterData: dataRow.counterData,
                  furnish_guarantors: dataRow.furnish_guarantors,
                  application_product_status:
                    dataRow.application_product_status,
                  is_counter_offer_accepted: dataRow.is_counter_offer_accepted,
                  agent_name: dataRow?.agentInfo?.name,
                  product_dis_info: dataRow?.disbursementinfo,
                  aa_files: dataRow?.aa_files,
                  app_provid_name: dataRow?.providerName,
                },
              ],
              loan_application_id: dataRow.id,
              dealer_id: dataRow.dealer,
            });
          });
        }
      } else if (loanDetailName == "In-House") {
        loanItemsData = [];
        if (
          data.products?.["In-House"] != undefined &&
          data.products?.["In-House"].length > 0
        ) {
          let inhouse_data = data.products?.["In-House"];
          inhouse_data.map((dataRow) => {
            loanItemsData.push({
              provider_name: dataRow.name,
              provider_id: dataRow.id,
              provider_icon: dataRow.icon,
              sortInterestData: dataRow.int_rate,
              application_product_status: dataRow.application_product_status,
              main_dis_info: data.disbursementinfo,
              product_id: dataRow.id,
              products: [
                {
                  product_name: dataRow.name,
                  provider_name: dataRow.name,
                  interest: dataRow.int_rate,
                  interest_id: dataRow.activeinterest?.id,
                  product_id: dataRow.id,

                  agentcommision: dataRow.agentcommision,
                  application_product: dataRow.application_product,
                  loan_amt: parseInt(dataRow.loanamount).toFixed(0),
                  tenor: dataRow.tenure,
                  dealer_commission_percentage: dataRow.commision_percentage,
                  dealer_commission_amount:
                    parseInt(dataRow.loanamount) *
                    (parseFloat(dataRow.commision_percentage) / 100),
                  admin_fee: dataRow.adminfee,
                  mnthly_installement: dataRow.monthly_installment,
                  scheme: dataRow.schemeinfo?.name,
                  status: dataRow.agentupdatestatus,
                  parf: dataRow.parfvalue,
                  available_guarantors: data.guarantor_details.filter(
                    (item) => item.guarantor_status_update == null
                  ),
                  type: "In-House",
                  agentupdatestatus: dataRow.agentupdatestatus,
                  counterData: dataRow.counterData,
                  furnish_guarantors: dataRow.furnish_guarantors,
                  application_product_status:
                    dataRow.application_product_status,
                  is_counter_offer_accepted: dataRow.is_counter_offer_accepted,
                  agent_name: dataRow?.agentInfo?.name,
                  product_dis_info: dataRow?.disbursementinfo,
                  aa_files: dataRow?.aa_files,
                  app_provid_name: dataRow?.providerName,
                  last_installment: dataRow.last_installment,
                  remarks: dataRow.remarks,
                  terms_and_conditions: dataRow.terms_and_conditions,
                },
              ],
              loan_application_id: dataRow.id,
              dealer_id: dataRow.dealer,
            });
          });
        }
      }
    }
    const temp = SortItems(
      loanItemsData?.map((it) => {
        return {
          ...it,
          dealerComm: it.products[0]?.dealer_commission_percentage,
        };
      })
    );
    const Array = temp?.map((it) => it?.products).flat();
    const DisburArray = Array?.filter((itx) => itx?.product_dis_info !== null);

    Loanitems = temp.map((data, idx) => {
      return {
        key: idx + 1,
        label: (
          <AccordionHeader
            title={`Loan Application(s) for ${data.provider_name}`}
            icon={data.provider_icon}
            scheme={data.products[0].scheme}
            productName={data.products[0].product_name}
          />
        ),
        children: (
          <LoanCaseData
            mainDisInfo={data.main_dis_info}
            dataRows={data.products}
            icon={data.provider_icon}
            title={data.provider_name}
            reloadData={reloadData}
            comp={{ setDocumentPreview, setDocumentUrl, fileType }}
            pagePermission={pagePermission}
            ID={data?.product_id}
            disbursementForm={
              DisburArray?.length > 0 && DisburArray !== undefined
                ? disbursementForm?.concat(DisburArray[0]?.product_id)
                : disbursementForm
            }
            setDisbursementForm={setDisbursementForm}
          />
        ),
        title: `${data.provider_name}`,
        intrate: `${data.sortInterestData}`,
        applstatus: `${data.application_product_status}`,
      };
    });
    setOriginalLoanTabDetails(Loanitems);
    Loanitems = Loanitems.filter((item) => item.applstatus === applActiveTab);
    setLoanTabDetails(Loanitems);

  }, [loanDetailName, data, applActiveTab, disbursementForm]);

  useEffect(() => {
    setCompMount(true);
  }, [type]);

  useEffect(() => {
    if (tabStatus === null) {
      async function GetSettings() {
        let res = await axios.get("/settings");
        setSettings(res.data?.data);
      }
      GetSettings();
      if (redirectStatus == 'true') {
        setGuarntorEdit(true);
      } else {
        dispatch(resetGuarantorsButton());
        dispatch(resetGuarantors());
      }
    } else {
      setGuarntorEdit(true);
      sessionStorage.removeItem("updatedStatus");
    }
  }, []);

  const handleAddGuarantor = (id, minIncome) => {
    console.log("clicked id", id)
    console.log("guarantorDetails id", guarantorDetails)

    if (getButtonCount <= 3) {
      if (getButtonCount == 0) {
        setClickAddBtn(true);
      }
      setTimeout(() => {
        dispatch(addGuarantorButton({ id, minIncome }));
      }, 10);
      setGuarntorEdit(true);

      if (typeof window.addGuarantorTab === "function") {
        window.addGuarantorTab(id);
      };
    } else {
      toast.error("The maximum guarantor limit has been reached.");
      setGuarntorEdit(false);
    }
  };

  const ApplicantInfo = data?.applicant_details;
  const EmploymentDetails = data?.applicant_employement_details;
  return (
    <div className="empty-product-info">
      <div
        className="app-detail-tab-content mx-5 mt-5 bg-white p-5"
        style={{ maxHeight: "100%" }}
      >
        {type === "vehicle" && (
          <Fragment>
            <div className="preview-details-head">
              <h1>Details</h1>
              {pagePermission?.update_permission == 1 && !isDisbursed && (
                <>
                  <Button
                    onClick={() => {
                      navigate("/details-edit", {
                        state: {
                          editType: "Vehicle",
                          editData: data.vehicle_details,
                          category: data.categoryinfo?.name,
                          editDataDocuments: data.vehicle_documents,
                          pagePermission: pagePermission,
                        },
                      });
                    }}
                    className="text-[#0F59F9] border border-[#0F59F9] min-[768px]:text-[14px] max-[768px]:text-[12px] flex ml-3"
                  >
                    <EditOutlined className="mt-1" />
                    Edit Details
                  </Button>
                </>
              )}
            </div>
            <div className="preview-list-block">
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Vehicle Type:</h3>
                  <p>{data?.typeinfo ? data?.typeinfo?.name : "N/A"}</p>
                </div>
                <div className="preview-list">
                  <h3>Vehicle Reg No:</h3>
                  <p>
                    {data.vehicle_details?.vehicle_reg_no
                      ? data.vehicle_details?.vehicle_reg_no
                      : "N/A"}
                  </p>
                </div>
                <div className="preview-list">
                  <h3>Access Code:</h3>
                  <p>{data?.vehicle_details?.access_code}</p>
                </div>
                <div className="preview-list">
                  <h3>Vehicle Make/Model:</h3>
                  <p>{data.vehicle_details?.make_model}</p>
                </div>
                <div className="preview-list">
                  <h3>OPC:</h3>
                  <p>
                    {data.vehicle_details?.is_opc_car == 1
                      ? "Yes, remains as OPC"
                      : "No"}
                  </p>
                </div>
              </div>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Y.O.M:</h3>
                  <p>
                    {data.vehicle_details?.vehicle_yom
                      ? data.vehicle_details?.vehicle_yom
                      : "N/A"}
                  </p>
                </div>
                <div className="preview-list">
                  <h3>Purchase Price:</h3>
                  <p>$ {Math.round(data?.vehicle_details?.vehicle_purchase_price)}</p>
                </div>
                <div className="preview-list">
                  <h3>Selling Price:</h3>
                  <p>$ {Math.round(data?.vehicle_details?.selling_price)}</p>
                </div>
                <div className="preview-list">
                  <h3>OMV:</h3>
                  <p>$ {Math.round(data?.vehicle_details?.vehicle_omv)}</p>
                </div>
                <div className="preview-list">
                  <h3>Engine No:</h3>
                  <p>{data?.vehicle_details?.vehicle_engine_no}</p>
                </div>
              </div>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Chassis No:</h3>
                  <p>{data?.vehicle_details?.vehicle_chassis_no}</p>
                </div>
                <div className="preview-list">
                  <h3>Reg Date:</h3>
                  <p>
                    {data?.vehicle_details?.vehicle_ori_reg_date !== "" &&
                      data?.vehicle_details?.vehicle_ori_reg_date !== null
                      ? dayjs(
                        data?.vehicle_details?.vehicle_ori_reg_date,
                        "YYYY-MM-DD"
                      ).format("DD-MM-YYYY")
                      : ""}
                  </p>
                </div>
                <div className="preview-list">
                  <h3> COE-QP / PQP Paid:</h3>
                  <p>$ {data?.vehicle_details?.vehicle_coe_amount}</p>
                </div>
                <div className="preview-list">
                  <h3> ARF Paid:</h3>
                  <p>$ {Math.round(data?.vehicle_details?.arf_paid)}</p>
                </div>
                <div className="preview-list">
                  <h3> Transfer count:</h3>
                  <p>{data?.vehicle_details?.transfer_count}</p>
                </div>
              </div>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Loan To Value:</h3>
                  <p>{data?.vehicle_details?.loan_to_value} %</p>
                </div>
              </div>
            </div>
            <Row gutter={[24, 0]}>
              <Col xs={24} sm={24} md={12} lg={12} className="">
                <p className="mt-5 text-[15px] font-[600]">
                  Document(s) Uploaded{" "}
                </p>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} className="text-right">
                <div className="justify-between items-center mb-2">
                  <Popover
                    content={
                      <div>
                        <Button
                          type="primary"
                          onClick={() => {
                            downloadDocuments(type);
                          }}
                          className="min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex w-[155px] mb-2"
                        >
                          <FileZipOutlined className="mr-2 mt-1" />
                          <p>Download Zip</p>
                        </Button>
                        <Button
                          type="primary"
                          onClick={() => {
                            downloadDocumentsUnzip(type);
                          }}
                          className="min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex w-[155px]"
                        >
                          <DownloadOutlined className="mr-2 mt-1" />
                          <p>Download Files</p>
                        </Button>
                      </div>
                    }
                    placement="bottom"
                    trigger="hover"
                    open={downloadPopOver}
                    onOpenChange={handleOpenChange}
                  >
                    <Button
                      className=" mt-4 min-[768px]:text-[14px] max-[768px]:text-[12px]"
                      type="primary"
                    >
                      Download All Documents
                    </Button>
                  </Popover>
                </div>
              </Col>
            </Row>
            <Row gutter={[16, 16]} className="mb-1 mt-4">
              {dataDocuments !== undefined &&
                dataDocuments.length > 0 &&
                dataDocuments.map((doc, index) => {
                  const key = Object.keys(doc)[0];
                  const valueLength = doc[key].length;
                  let words = key.split("_");
                  for (let i = 0; i < words.length; i++) {
                    words[i] =
                      words[i].charAt(0).toUpperCase() + words[i].slice(1);
                  }
                  let result = words.join(" ");
                  if (result.length <= 4) {
                    result = result.toUpperCase();
                  }
                  const shouldStartNewRow = index > 0 && index % 4 === 0;

                  return (
                    <>
                      {shouldStartNewRow && (
                        <div style={{ flexBasis: "100%", height: 0 }}></div>
                      )}
                      <Col>
                        <div className="sm:w-2/2 lg:w-4/4 mt-1 flex py-2 w-[250px] px-2">
                          <img
                            style={{ width: "15px", height: "15px" }}
                            className="mr-3 mt-[2px]"
                            src={"/images/" + "additional_documents" + ".png"}
                          />
                          <div className="w-full flex">
                            <div className="text-[13px] font-[500] text-[#0D062D]">
                              {result === "Vehicle Overseas Log Card"
                                ? "V5/Overseas Logcard"
                                : result}
                            </div>
                          </div>
                        </div>
                        {doc[key].map((data) => {
                          let valType = false;
                          let imgType = "";
                          if (typeof data === "object") {
                            valType = true;
                            let popType = data.value.split(".").pop();
                            if (popType === "pdf") {
                              imgType = "pdf";
                            } else if (popType === "docx") {
                              imgType = "docx";
                            }
                          }
                          return (
                            <Fragment>
                              <div className="sm:w-2/2 lg:w-4/4 mt-1 flex border rounded py-2 w-full px-2">
                                {imgType === "pdf" ? (
                                  <FilePdfOutlined className="pdfOutlineStyle" />
                                ) : imgType === "docx" ? (
                                  <FileWordOutlined className="pdfOutlineStyle" />
                                ) : (
                                  <img
                                    style={{ width: "50px", height: "50px" }}
                                    className="mr-3 mt-[2px]"
                                    src={
                                      valType
                                        ? IMAGE_BASE_URL + data.value
                                        : IMAGE_BASE_URL + data
                                    }
                                  />
                                )}
                                <div className="w-full justify-between flex mt-4">
                                  <div className="text-[13px] font-[500] text-[#0D062D] whitespace-nowrap truncate max-w-[150px]">
                                    {data.name}
                                  </div>
                                  <div>
                                    <div className="text-right">
                                      <img
                                        src="/images/document_download.png"
                                        alt="Download Document"
                                        className="max-w-xs cursor-pointer ml-auto"
                                        onClick={() => {
                                          setDocumentPreview(true);
                                          setDocumentUrl(data.value);
                                          fileType(data.value);
                                          // DownloadDocumentFile();
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="w-full flex justify-between items-center mt-1">
                                <p className="text-left font-lato text-[12px] text-[500] text-instruction-grey opacity-60 mt-1"></p>
                              </div>
                            </Fragment>
                          );
                        })}
                        <div></div>
                      </Col>
                    </>
                  );
                })}
            </Row>
            {/* <Row gutter={[16, 16]} className='mt-[50px]'>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Button className='text-[#0F59F9] border border-[#0F59F9] min-[768px]:text-[14px] max-[768px]:text-[12px]'>
                SGCM Link
              </Button>
            </Col>
          </Row> */}
          </Fragment>
        )}
        {type == "applicant" && (
          <Fragment>
            <div className="preview-details-head">
              <h1>Details</h1>
              {pagePermission?.update_permission == 1 && !isDisbursed && (
                <Button
                  onClick={() => {
                    navigate("/details-edit", {
                      state: {
                        editType: "Applicant",
                        editData: data.applicant_details,
                        category: data.categoryinfo?.name,
                        editDataDocuments: data.applicant_documents,
                        employmentData: data.applicant_employement_details,
                        pagePermission: pagePermission,
                      },
                    });
                  }}
                  className="text-[#0F59F9] border border-[#0F59F9] min-[768px]:text-[14px] max-[768px]:text-[12px] flex ml-3"
                >
                  <EditOutlined className="mt-1" />
                  Edit Details
                </Button>
              )}
            </div>
            {ApplicantInfo?.typeinfo?.applicant_type === "Company" ? (
              <div className="preview-list-block">
                <div className="preview-list-group">
                  <div className="preview-list">
                    <h3>Applying As:</h3>
                    <p>{data.applicant_details?.typeinfo?.applicant_type}</p>
                  </div>
                  <div className="preview-list">
                    <h3>Company Name:</h3>
                    <p>{data.applicant_details?.company_name}</p>
                  </div>
                  <div className="preview-list">
                    <h3>UEN/ACRA No:</h3>
                    <p>{data.applicant_details?.uen_acra_no}</p>
                  </div>
                  <div className="preview-list">
                    <h3>UEN/ACRA No:</h3>
                    <p>{data.applicant_details?.uen_acra_no}</p>
                  </div>
                  <div className="preview-list">
                    <h3> Date of Incorporation:</h3>
                    <p>
                      {data.applicant_details?.date_of_incorporation !== "" &&
                        data.applicant_details?.date_of_incorporation !== null
                        ? dayjs(
                          data.applicant_details?.date_of_incorporation,
                          "YYY-MM-DD"
                        ).format("DD-MM-YYYY")
                        : ""}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Mobile Number:</h3>
                    <p>{data.applicant_details?.mobile_no}</p>
                  </div>
                  <div className="preview-list">
                    <h3>Office Number:</h3>
                    <p>{data.applicant_details?.office}</p>
                  </div>
                  <div className="preview-list">
                    <h3>Email:</h3>
                    <p>{data.applicant_details?.email}</p>
                  </div>
                  <div className="preview-list">
                    <h3>Contact Person:</h3>
                    <p>{data.applicant_details?.name}</p>
                  </div>
                  <div className="preview-list">
                    <h3>Company Address:</h3>
                    <p>{data.applicant_details?.company_address}</p>
                  </div>
                  <div className="preview-list">
                    <h3>Postal Code:</h3>
                    <p>{data.applicant_details?.company_postal_code}</p>
                  </div>
                  <div className="preview-list">
                    <h3>Mailing Address:</h3>
                    <p>
                      {data.applicant_details?.mailing_company_address !== "" &&
                        data.applicant_details?.mailing_company_address != null
                        ? data.applicant_details?.mailing_company_address
                        : data.applicant_details?.company_address}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Mailing Postal Code:</h3>
                    <p>
                      {ApplicantInfo?.mailing_company_postal_code !== "" &&
                        ApplicantInfo?.mailing_company_postal_code != null
                        ? ApplicantInfo?.mailing_company_postal_code
                        : ApplicantInfo?.company_postal_code}
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="preview-list-block">
                <div className="preview-list-group">
                  <div className="preview-list">
                    <h3>Applying As:</h3>
                    <p>{data.applicant_details?.typeinfo?.applicant_type}</p>
                  </div>
                  <div className="preview-list">
                    <h3>Title:</h3>
                    <p>{data.applicant_details?.title}</p>
                  </div>
                  <div className="preview-list">
                    <h3>Name:</h3>
                    <p>
                      {data.applicant_details?.name
                        ? data.applicant_details?.name
                        : data.applicant_details?.company_name}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>NRIC:</h3>
                    <p>{data.applicant_details?.nric}</p>
                  </div>
                  <div className="preview-list">
                    <h3>Race:</h3>
                    <p>{data.applicant_details?.race}</p>
                  </div>

                  <div className="preview-list">
                    <h3>Date of Birth:</h3>
                    <p>
                      {moment(data.applicant_details?.dob).format("DD-MM-YYYY")}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Email:</h3>
                    <p>
                      {data.applicant_details?.email
                        ? data.applicant_details?.email
                        : "-"}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Marital Status:</h3>
                    <p>{data.applicant_details?.marital_status}</p>
                  </div>
                  <div className="preview-list">
                    <h3>Gender:</h3>
                    <p>
                      {data.applicant_details?.gender
                        ? data.applicant_details?.gender
                        : "-"}
                    </p>
                  </div>
                  {data.applicant_details?.marital_status === "Married" && (
                    <div className="preview-list">
                      <h3>Name of Spouse:</h3>
                      <p>
                        {data.applicant_details?.name_of_spouse
                          ? data.applicant_details?.name_of_spouse
                          : "-"}
                      </p>
                    </div>
                  )}
                  <div className="preview-list">
                    <h3>Residence:</h3>
                    <p>{data.applicant_details?.residence_type}</p>
                  </div>
                  <div className="preview-list">
                    <h3>Mobile No:</h3>
                    <p>{data.applicant_details?.mobile_no}</p>
                  </div>
                  <div className="preview-list">
                    <h3>Office No:</h3>
                    <p>
                      {data.applicant_details?.office
                        ? data.applicant_details?.office
                        : "-"}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Home No:</h3>
                    <p>
                      {data.applicant_details?.home_no
                        ? data.applicant_details?.home_no
                        : "-"}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Address:</h3>
                    <p>
                      {" "}
                      {data.applicant_details?.home_address
                        ? data.applicant_details?.home_address
                        : "-"}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Postal Code:</h3>
                    <p>
                      {" "}
                      {data.applicant_details?.postal_code
                        ? data.applicant_details?.postal_code
                        : "-"}
                    </p>
                  </div>
                  { }
                  <div className="preview-list">
                    <h3>Mailing Residence Type:</h3>
                    <p>
                      {" "}
                      {data.applicant_details?.home_address_same_as_mailing == 0
                        ? data.applicant_details?.mailing_residence_type
                        : data.applicant_details?.mailing_home_address}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Mailing Address:</h3>
                    <p>
                      {" "}
                      {data.applicant_details?.home_address_same_as_mailing == 1
                        ? data.applicant_details?.home_address
                        : data.applicant_details?.mailing_home_address}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Mailing Postal Code:</h3>
                    <p>
                      {" "}
                      {data.applicant_details?.home_address_same_as_mailing == 1
                        ? data.applicant_details?.postal_code
                        : data.applicant_details?.mailing_postal_code}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Employment:</h3>
                    <p>
                      {data.applicant_employement_details?.employment_type?.trim()
                        ? data.applicant_employement_details.employment_type
                        : 'Unemployed'}
                    </p>
                  </div>
                  {ApplicantInfo?.typeinfo?.applicant_type ===
                    "Work Pass Holder(FIN)" ||
                    (ApplicantInfo?.typeinfo?.applicant_type ===
                      "Foreign Work Pass(Passport)" && (
                        <>
                          <div className="preview-list">
                            <h3>Nationality/Country:</h3>
                            <p>
                              {data.applicant_details?.nationality
                                ? data.applicant_details?.nationality
                                : "-"}
                            </p>
                          </div>
                          <div className="preview-list">
                            <h3>FIN No:</h3>
                            <p>{data.applicant_details?.fin_no}</p>
                          </div>
                          <div className="preview-list">
                            <h3> Passport No:</h3>
                            <p>{data.applicant_details?.passport_no}</p>
                          </div>
                          <div className="preview-list">
                            <h3>Passport Expiry:</h3>
                            <p>{data.applicant_details?.passport_expiry_date}</p>
                          </div>
                        </>
                      ))}
                </div>
              </div>
            )}

            {showMore &&
              data.applicant_employement_details &&
              data.applicant_employement_details?.employment_type !=
              "Unemployed" &&
              ApplicantInfo?.typeinfo?.applicant_type !== "Company" ? (
              <>
                <div className="preview-list-block">
                  <div className="preview-list-group">
                    <div className="preview-list">
                      <h3>Occupation:</h3>
                      <p>{EmploymentDetails?.occupation}</p>
                    </div>
                    <div className="preview-list">
                      <h3>Income Type:</h3>
                      <p>
                        {data.applicant_employement_details?.finance_type
                          ? data.applicant_employement_details?.finance_type
                          : "-"}
                      </p>
                    </div>
                    <div className="preview-list">
                      <h3>Type of Industry:</h3>
                      <p>
                        {data.applicant_employement_details?.type_of_industry
                          ? data.applicant_employement_details?.type_of_industry
                          : "-"}
                      </p>
                    </div>
                    <div className="preview-list">
                      <h3>Monthly Income:</h3>
                      <p>
                        {data.applicant_employement_details?.monthly_income
                          ? " $ " +
                          data.applicant_employement_details?.monthly_income
                          : "-"}
                      </p>
                    </div>
                    <div className="preview-list">
                      <h3>Other Monthly Income:</h3>
                      <p>
                        {data.applicant_employement_details?.other_income
                          ? " $ " +
                          data.applicant_employement_details?.other_income
                          : "-"}
                      </p>
                    </div>
                    <div className="preview-list">
                      <h3>Length of Service:</h3>
                      <p>
                        {(data.applicant_employement_details
                          ?.service_duration_years &&
                          data.applicant_employement_details
                            ?.service_duration_years + " years ") +
                          (data.applicant_employement_details
                            ?.service_duration_months &&
                            data.applicant_employement_details
                              ?.service_duration_months + " months ")}
                      </p>
                    </div>
                    <div className="preview-list">
                      <h3>Employer Name:</h3>
                      <p>
                        {data.applicant_employement_details?.employer_name
                          ? data.applicant_employement_details?.employer_name
                          : "-"}
                      </p>
                    </div>
                    <div className="preview-list">
                      <h3>Employer Address:</h3>
                      <p>
                        {data.applicant_employement_details?.employer_address
                          ? data.applicant_employement_details?.employer_address
                          : "-"}
                      </p>
                    </div>
                    <div className="preview-list">
                      <h3>Employer Postal Code:</h3>
                      <p>
                        {data.applicant_employement_details
                          ?.employer_postal_code
                          ? data.applicant_employement_details
                            ?.employer_postal_code
                          : "-"}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="preview-list-block">
                  <div className="preview-list-group">
                    <div className="preview-list">
                      <h3>Prev. Occupation:</h3>
                      <p>
                        {data.applicant_employement_details
                          ?.employer_previous_occupation
                          ? data.applicant_employement_details
                            ?.employer_previous_occupation
                          : "-"}
                      </p>
                    </div>
                    <div className="preview-list">
                      <h3>Prev. Length of Service:</h3>
                      <p>
                        {(data.applicant_employement_details
                          ?.employer_previous_experience_years &&
                          data.applicant_employement_details
                            ?.employer_previous_experience_years + " years ") +
                          (data.applicant_employement_details
                            ?.employer_previous_experience_months &&
                            data.applicant_employement_details
                              ?.employer_previous_experience_months +
                            " months ")}
                      </p>
                    </div>
                  </div>
                  <div className="preview-list-group">
                    <div className="preview-list">
                      <h3>Prev. Employer Name:</h3>
                      <p>
                        {data.applicant_employement_details
                          ?.employer_previous_name
                          ? data.applicant_employement_details
                            ?.employer_previous_name
                          : "-"}
                      </p>
                    </div>
                    <div className="preview-list">
                      <h3>Prev. Employer Address:</h3>
                      <p>
                        {data.applicant_employement_details
                          ?.employer_previous_address
                          ? data.applicant_employement_details
                            ?.employer_previous_address
                          : "-"}
                      </p>
                    </div>
                    <div className="preview-list">
                      <h3>Prev. Employer Postal Code:</h3>
                      <p>
                        {data.applicant_employement_details
                          ?.employer_previous_postal_code
                          ? data.applicant_employement_details
                            ?.employer_previous_postal_code
                          : "-"}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="text-center">
                  <Button
                    onClick={() => {
                      setShowMore(false);
                    }}
                    className="text-[#0F59F9] border border-[#0F59F9] min-[768px]:text-[14px] max-[768px]:text-[12px] mt-2"
                  >
                    See Less Details
                  </Button>
                </div>
              </>
            ) : null}
            {!showMore &&
              data.applicant_employement_details?.employment_type !==
              "Unemployed" &&
              ApplicantInfo?.typeinfo?.applicant_type !== "Company" && (
                <div className="text-center mb-2">
                  <Button
                    onClick={() => {
                      setShowMore(true);
                    }}
                    className="text-[#0F59F9] border border-[#0F59F9] min-[768px]:text-[14px] max-[768px]:text-[12px] mt-2"
                  >
                    Show More Details
                  </Button>
                </div>
              )}
            <Row gutter={[24, 0]}>
              <Col xs={24} sm={24} md={12} lg={12} className="">
                <p className="mt-5 text-[15px] font-[600]">
                  Document(s) Uploaded{" "}
                </p>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} className="text-right">
                <div className="justify-between items-center mb-2">
                  <Popover
                    content={
                      <div>
                        <Button
                          type="primary"
                          onClick={() => {
                            downloadDocuments(type);
                          }}
                          className="min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex w-[155px] mb-2"
                        >
                          <FileZipOutlined className="mr-2 mt-1" />
                          <p>Download Zip</p>
                        </Button>
                        <Button
                          type="primary"
                          onClick={() => {
                            downloadDocumentsUnzip(type);
                          }}
                          className="min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex w-[155px]"
                        >
                          <DownloadOutlined className="mr-2 mt-1" />
                          <p>Download Files</p>
                        </Button>
                      </div>
                    }
                    placement="bottom"
                    trigger="hover"
                    open={downloadPopOver}
                    onOpenChange={handleOpenChange}
                  >
                    <Button
                      className=" mt-4 min-[768px]:text-[14px] max-[768px]:text-[12px]"
                      type="primary"
                    >
                      Download All Documents
                    </Button>
                  </Popover>
                </div>
              </Col>
            </Row>
            <Row gutter={[16, 16]} className="mb-1 mt-4">
              {dataDocuments !== undefined &&
                dataDocuments.length > 0 &&
                dataDocuments.map((doc, index) => {
                  const key = Object.keys(doc)[0];
                  const valueLength = doc[key].length;
                  let words = key.split("_");
                  for (let i = 0; i < words.length; i++) {
                    words[i] =
                      words[i].charAt(0).toUpperCase() + words[i].slice(1);
                  }
                  let result = words.join(" ");
                  if (result.length <= 4) {
                    result = result.toUpperCase();
                  }
                  // Determine if a new row should start
                  const shouldStartNewRow = index > 0 && index % 4 === 0;

                  return (
                    <>
                      {shouldStartNewRow && (
                        <div style={{ flexBasis: "100%", height: 0 }}></div>
                      )}
                      <Col>
                        <div className="sm:w-2/2 lg:w-4/4 mt-1 flex py-2 w-[250px] px-2">
                          <img
                            style={{ width: "15px", height: "15px" }}
                            className="mr-3 mt-[2px]"
                            src={"/images/" + "additional_documents" + ".png"}
                          />
                          <div className="w-full flex">
                            <div className="text-[13px] font-[500] text-[#0D062D]">
                              {result === "NAO" ? "NOA" : result}
                            </div>
                          </div>
                        </div>
                        {doc[key].map((data) => {
                          let valType = false;
                          let imgType = "";
                          if (typeof data === "object") {
                            valType = true;
                            let popType = data.value.split(".").pop();
                            if (popType === "pdf") {
                              imgType = "pdf";
                            } else if (popType === "docx") {
                              imgType = "docx";
                            }
                          }
                          return (
                            <Fragment>
                              <div className="sm:w-2/2 lg:w-4/4 mt-1 flex border rounded py-2 w-full px-2">
                                {imgType === "pdf" ? (
                                  <FilePdfOutlined className="pdfOutlineStyle" />
                                ) : imgType === "docx" ? (
                                  <FileWordOutlined className="pdfOutlineStyle" />
                                ) : (
                                  <img
                                    style={{ width: "50px", height: "50px" }}
                                    className="mr-3 mt-[2px]"
                                    src={
                                      valType
                                        ? IMAGE_BASE_URL + data.value
                                        : IMAGE_BASE_URL + data
                                    }
                                  />
                                )}
                                <div className="w-full flex justify-between mt-4">
                                  <div className="text-[13px] font-[500] text-[#0D062D] whitespace-nowrap truncate max-w-[150px]">
                                    {valType
                                      ? data.name
                                      : data.split("/").pop()}
                                  </div>
                                  <div>
                                    <div className="text-right">
                                      <img
                                        src="/images/document_download.png"
                                        alt="Download Document"
                                        className="max-w-xs cursor-pointer ml-auto"
                                        onClick={() => {
                                          setDocumentPreview(true);
                                          setDocumentUrl(
                                            valType ? data.value : data
                                          );
                                          fileType(valType ? data.value : data);
                                          // DownloadDocumentFile();
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="w-full flex justify-between items-center mt-1">
                                <p className="text-left font-lato text-[12px] text-[500] text-instruction-grey opacity-60 mt-1"></p>
                              </div>
                            </Fragment>
                          );
                        })}
                        <div></div>
                      </Col>
                    </>
                  );
                })}
            </Row>
          </Fragment>
        )}
        {type == "guarantor" && (
          <Fragment>
            <div className="preview-details-head">
              {!gurantorEdit && (
                <>
                  <h1>Details</h1>
                  {/* {getButtonCount == 1 && ( */}
                  <Button
                    onClick={() => {
                      setGuarntorEdit(true);
                    }}
                    className="text-[#0F59F9] border border-[#0F59F9] min-[768px]:text-[14px] max-[768px]:text-[12px] flex ml-3"
                  >
                    <EditOutlined className="mt-1" />
                    Edit Details
                  </Button>
                  {/* )} */}
                </>
              )}
            </div>
            {data?.furnish_guarantors &&
              data?.furnish_guarantors.length > 0 && (
                <div className="bg-[#D9E7FE] border border-[#E3E3E3] rounded-[10px] p-[15px_20px_0_15px] mb-[15px]">
                  <h5 className="text-[#0D062D] text-[14px] font-[700] mb-[10px]">
                    Furnish Guarantor
                  </h5>
                  {data?.furnish_guarantors.map((fItem, idx) => {
                    if ((removeGuarantorLabel || []).includes(fItem.id)) return null;
                    return (
                      <div className="mb-[15px]" key={idx}>
                        <p className="text-[#27272B] text-[13px] font-[500]">
                          {fItem?.agentinfo?.name} Required Additional Guarantor
                          <Button
                            onClick={() => {
                              handleAddGuarantor(fItem.id, fItem?.guarantor_income);
                            }}
                            className="text-[#0F59F9] border border-[#0F59F9] min-[768px]:text-[14px] max-[768px]:text-[12px]  ml-3"
                            size="small"
                          >
                            Add
                          </Button>
                        </p>
                        <p className="mt-[3px] text-[13px] font-[500] text-[#27272B]">
                          <span className="font-[600]">Guarantor (1)</span> -{" "}
                          {fItem?.guarantor_relation}, Min. Income: $
                          {fItem?.guarantor_income}
                        </p>
                      </div>
                    );
                  })}
                </div>
              )}
            <div className="relative">
              {gurantorEdit ? (
                <GurantorEdit
                  editType={"Guarantor"}
                  comp={{ setGuarntorEdit, reloadData }}
                  setClickAddBtn={setClickAddBtn}
                  clickAddBtn={clickAddBtn}
                  existingGuarantors={data?.guarantor_details}
                />
              ) : (

                <>
                  <Tabs
                    className="mt-[0px] !overflow-hidden"
                    defaultActiveKey="1"
                    onChange={(value) => {
                      setSelectedGuarantorTab(value);
                    }}
                    items={GuarantorItems}
                  />
                </>

              )}
            </div>
          </Fragment>
        )}
        {type == "loan" && (
          <Fragment>
            <div className="flex justify-between items-center flex-wrap addApplBox mb-[20px]">
              <LoanSwitchBox
                handler={(key) => {
                  dispatch(
                    setLoanApplicationDetailsFilter({ loanDetailName: key })
                  );
                  setLoanDetailName(key);
                }}
                tabs={[
                  { name: "All", dataKey: "All" },
                  { name: "Bank", dataKey: "Bank" },
                  {
                    name: "Financial Institution",
                    dataKey: "Financial_Institution",
                  },
                  { name: "In-House", dataKey: "In-House" },
                ]}
                activeKey={loanDetailName}
              />
              <div className="flex items-center flex-wrap gap-[10px_60px]">
                <div>
                  <Input
                    className="notSearchInp"
                    prefix={<img src="/images/search.svg" alt="search" />}
                    placeholder="Search..."
                    allowClear
                    value={searchVal}
                    onChange={(e) => {
                      const val = e.target.value.toLowerCase();
                      const filteredItem = originalloanTabDetails.filter(
                        (item) => {
                          if (
                            item.title.toLowerCase().includes(val) &&
                            item.applstatus === applActiveTab
                          ) {
                            return item;
                          }
                        }
                      );
                      setSearchVal(e.target.value);
                      setLoanTabDetails(filteredItem);
                    }}
                  />
                </div>
                <div className="flex gap-[7px] items-center">
                  <span className="flex gap-[5px] items-center text-[#59758A] text-[12px]">
                    <img src="/images/srt_arr.svg" />
                    Sort by:
                  </span>
                  <Select
                    className="sortBySelect"
                    rootClassName="sortBySelectDrop"
                    suffixIcon={false}
                    defaultValue={loanDetailSortkey}
                    value={loanDetailSortkey}
                    options={[
                      {
                        label: "Loan Comm. (Highest - Lowest %)",
                        value: "hlComm",
                      },
                      {
                        label: "Loan Comm. (Lowest - Highest %)",
                        value: "lhComm",
                      },
                    ]}
                    onChange={(val) => {
                      setLoanDetailSortkey(val);
                      dispatch(
                        setLoanApplicationDetailsFilter({
                          loanDetailSortkey: val,
                        })
                      );
                      const reversed = [...loanTabDetails].reverse();
                      setLoanTabDetails(reversed);
                    }}
                  />
                </div>

                {Object.keys(data)?.length > 0 &&
                  pagePermission?.create_permission == 1 &&
                  data?.rejectedCount ===
                  Object.values(data?.products).flat()?.length && (
                    <>
                      {pagePermission?.create_permission == 1 && (
                        <Button
                          type="primary"
                          className="addApplBtn"
                          onClick={() => {
                            navigate("/loan-application", {
                              state: FloorPagePErmission,
                            });
                            navigate(
                              `/loan-application?generate=true&loan=${Number(
                                data.loanamount
                              )}&tenor=${data?.tenure}&vehTyp=${data?.loanType
                              }&parfvalue=${Number(
                                data?.parfvalue
                              )}&tnr_type=month&applicationID=${data?.id}`,
                              { state: pagePermission }
                            );
                          }}
                        >
                          <span>+</span>
                          Add Application
                        </Button>
                      )}
                    </>
                  )}
              </div>
            </div>
            {loanTabDetails.length > 0 ? (
              <div className="loan-acc-section">
                <Collapse
                  collapsible="icon"
                  className="loan-collpase"
                  defaultActiveKey={["1", "2", "3", "4", "5", "6", "7"]}
                  expandIconPosition={"end"}
                  expandIcon={({ isActive }) => (
                    <div className="icon-container">
                      <span
                        className={`loan-acc-btn ${isActive ? "down-arrow" : ""
                          }`}
                      >
                        <CircleArrow />
                      </span>
                    </div>
                  )}
                  items={loanTabDetails}
                />
              </div>
            ) : (
              <div
                className='"whitespace-nowrap px-5 py-4 text-center  text-[13px] w-full'
                colSpan={11}
              >
                {" "}
                No Products Available
              </div>
            )}
          </Fragment>
        )}
        {type == "dealer" && (
          <div className="border rounded-xl mx-3 p-3 my-3">
            <Row gutter={[16, 16]} className="">
              <Col xs={24} sm={24} md={12} lg={12}>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <p className="detail-label mb-3">Dealer:</p>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    className="text-[12px] font-[500]"
                  >
                    <p>{data.dealer_info?.name}</p>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <p className="detail-label mb-3">Office No.:</p>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    className="text-[12px]  font-[500]"
                  >
                    -
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <p className="detail-label mb-3">Point of Contact:</p>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    className="text-[12px]  font-[500]"
                  >
                    {data.dealer_info?.contacts[0]?.name}
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <p className="detail-label mb-3">Mobile No.:</p>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    className="text-[12px]  font-[500]"
                  >
                    {data.dealer_info?.countryCode +
                      " " +
                      data.dealer_info?.phoneNumber}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        )}
        {type == "disbursement" && (
          <Fragment>
            <Row gutter={[16, 16]} className="mb-1 mt-4">
              {dataDocuments !== undefined && dataDocuments.length > 0 ? (
                dataDocuments.map((doc, index) => {
                  const key = Object.keys(doc)[0];
                  const valueLength = doc[key].length;
                  let words = key.split("_");
                  for (let i = 0; i < words.length; i++) {
                    words[i] =
                      words[i].charAt(0).toUpperCase() + words[i].slice(1);
                  }
                  let result = words.join(" ");
                  if (result.length <= 4) {
                    result = result.toUpperCase();
                  }
                  // Determine if a new row should start
                  const shouldStartNewRow = index > 0 && index % 4 === 0;

                  return (
                    <>
                      {shouldStartNewRow && (
                        <div style={{ flexBasis: "100%", height: 0 }}></div>
                      )}
                      <Col>
                        <div className="sm:w-2/2 lg:w-4/4 mt-1 flex py-2 w-[250px] px-2">
                          <img
                            style={{ width: "15px", height: "15px" }}
                            className="mr-3 mt-[2px]"
                            src={"/images/" + "additional_documents" + ".png"}
                          />
                          <div className="w-full flex">
                            <div className="text-[13px] font-[500] text-[#0D062D]">
                              {result === "NAO" ? "NOA" : result}
                            </div>
                          </div>
                        </div>
                        {doc[key].map((data) => {
                          let valType = false;
                          let imgType = "";
                          if (typeof data === "object") {
                            valType = true;
                            let popType = data.value.split(".").pop();
                            if (popType === "pdf") {
                              imgType = "pdf";
                            } else if (popType === "docx") {
                              imgType = "docx";
                            }
                          }
                          return (
                            <Fragment>
                              <div className="sm:w-2/2 lg:w-4/4 mt-1 flex border rounded py-2 w-full px-2">
                                {imgType === "pdf" ? (
                                  <FilePdfOutlined className="pdfOutlineStyle" />
                                ) : imgType === "docx" ? (
                                  <FileWordOutlined className="pdfOutlineStyle" />
                                ) : (
                                  <img
                                    style={{ width: "50px", height: "50px" }}
                                    className="mr-3 mt-[2px]"
                                    src={
                                      valType
                                        ? IMAGE_BASE_URL + data.value
                                        : IMAGE_BASE_URL + data
                                    }
                                  />
                                )}
                                <div className="w-full flex justify-between mt-4">
                                  <div className="text-[13px] font-[500] text-[#0D062D] whitespace-nowrap truncate max-w-[190px]">
                                    {valType
                                      ? data.name
                                      : data.split("/").pop()}
                                  </div>
                                  <div>
                                    <div className="text-right">
                                      <img
                                        src="/images/document_download.png"
                                        alt="Download Document"
                                        className="max-w-xs cursor-pointer ml-auto"
                                        onClick={() => {
                                          setDocumentPreview(true);
                                          setDocumentUrl(
                                            valType ? data.value : data
                                          );
                                          fileType(valType ? data.value : data);
                                          // DownloadDocumentFile();
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="w-full flex justify-between items-center mt-1">
                                <p className="text-left font-lato text-[12px] text-[500] text-instruction-grey opacity-60 mt-1"></p>
                              </div>
                            </Fragment>
                          );
                        })}
                        <div></div>
                      </Col>
                    </>
                  );
                })
              ) : (
                <div className="text-center w-full">No Disbursement Made</div>
              )}
            </Row>
            {data.disbursementinfo && (
              <div className="flex gap-[15px_30px] flex-wrap max-w-[900px] my-[30px]">
                <div className="flex-[1_1_200px]">
                  <label className="text-[#787486] text-[13px]">
                    Date of Disbursement
                    <Popover content={"Coming soon"} className="mt-[-2px]">
                      <img
                        src="/images/fi_info.svg"
                        alt="info"
                        className="inline-block ml-[8px] cursor-pointer"
                      />
                    </Popover>
                  </label>
                  <p className="font-[500] text-[13px]">{disbDate}</p>
                </div>
                <div className="flex-[1_1_300px]">
                  <label className="text-[#787486] text-[13px]">
                    Disbursement Document
                  </label>
                  {data?.disbursementinfo?.agent_disbursement_ack_doc ? (
                    <Fragment>
                      {data?.disbursementinfo?.agent_disbursement_ack_doc !==
                        undefined &&
                        data?.disbursementinfo?.agent_disbursement_ack_doc.map(
                          (doc, index) => {
                            let valType = false;
                            let imgType = doc.value.split(".").pop();
                            if (typeof doc === "object") {
                              valType = true;
                              let popType = "";
                              if (popType === "pdf") {
                                imgType = "pdf";
                              } else if (popType === "docx") {
                                imgType = "docx";
                              }
                            }
                            return (
                              <>
                                <div>
                                  <Fragment>
                                    <div className="sm:w-2/2 lg:w-4/4 mt-1 flex border rounded py-2 w-full px-2">
                                      {imgType === "pdf" ? (
                                        <FilePdfOutlined className="pdfOutlineStyle" />
                                      ) : imgType === "docx" ? (
                                        <FileWordOutlined className="pdfOutlineStyle" />
                                      ) : (
                                        <img
                                          style={{
                                            width: "50px",
                                            height: "50px",
                                          }}
                                          className="mr-3 mt-[2px]"
                                          src={
                                            valType
                                              ? IMAGE_BASE_URL + doc.value
                                              : IMAGE_BASE_URL + doc
                                          }
                                        />
                                      )}
                                      <div className="w-full flex justify-between mt-4">
                                        <div className="text-[13px] font-[500] text-[#0D062D] whitespace-nowrap truncate max-w-[180px]">
                                          {valType
                                            ? doc.name
                                            : doc.split("/").pop()}
                                        </div>
                                        <div>
                                          <div className="text-right">
                                            <img
                                              src="/images/document_download.png"
                                              alt="Download Document"
                                              className="max-w-xs cursor-pointer ml-auto"
                                              onClick={() => {
                                                setDocumentPreview(true);
                                                setDocumentUrl(
                                                  valType ? doc.value : doc
                                                );
                                                fileType(
                                                  valType ? doc.value : doc
                                                );
                                                // DownloadDocumentFile();
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="w-full flex justify-between items-center mt-1">
                                      <p className="text-left font-lato text-[12px] text-[500] text-instruction-grey opacity-60 mt-1"></p>
                                    </div>
                                  </Fragment>
                                </div>
                              </>
                            );
                          }
                        )}
                    </Fragment>
                  ) : (
                    <p className="font-[500] text-[13px]">N/A</p>
                  )}
                </div>
                <div className="flex-[1_1_200px]">
                  <label className="text-[#787486] text-[13px]">Remarks</label>
                  <p className="font-[500] text-[13px]">{disbRemarks}</p>
                </div>
              </div>
            )}
          </Fragment>
        )}
        <DocumentPreview
          open={documentPreview}
          close={() => {
            setDocumentPreview(false);
          }}
          title={type.charAt(0).toUpperCase() + type.slice(1) + "Document"}
          url={documentUrl}
          type={fileDocumentType}
        />
      </div>
    </div>
  );
};

export default CaseTabDetails;
